import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import SearchInputsComponent from '../../components/etmTickets/searchInputs'
import TripsTableComponent from '../../components/etmTickets/tripsTable'

import * as actions from './actions'
import { routePrefix } from '../../config'

import './styles.css'

class TripDetailsContainer extends React.Component {

  state = {
    // startDate: null,
    // routeName: '-1',
    focusedStartDate: false,
    isDataFetched: this.props.tripsData.length? true: false,
  };

  componentDidMount() {
    this.props.clearTicketDetails();
    this.props.getETMRoutes();
  }

  startDateRangeChecker = (date) => moment().diff(date) < 0

  //this.setState({ startDate: date })
  onStartDateChange = date => this.props.updateInputValues({ fieldName: 'startDate', value: date})

  onStartFocusChange = ({ focused }) => this.setState({ focusedStartDate: focused })

  //this.setState({ routeName: e.target.value })
  onRouteChange = (e) => this.props.updateInputValues({ fieldName: 'routeName', value: e.target.value })

  onDirectionChange = (e) => this.props.updateInputValues({ fieldName: 'direction', value: e.target.value })

  onSearchClick = () => {
    const { startDate, routeName, direction } = this.props;
    if(!startDate || routeName == '-1' || direction == '-1') {
      alert('Kindly fill all the fields.')
      return;
    }
    this.props.getTripsDetails({
      journeyDate: startDate.format('YYYY-MM-DD'),
      routeName,
      direction
    });
    this.setState({ isDataFetched: true });
  }

  onTripDetailsClick = (tripId) => this.props.history.push(routePrefix + '/etm-tickets/' + tripId)

  render() {
    const { isDataFetched } = this.state;
    const { startDate, routeName, direction, tripsData, etmRoutes, directions } = this.props;
    return (
      <div className="manage-user-wrp">
        <div className="row payout-header">
          <span className="payout-header-text">
            {isDataFetched? "ALAMBAGH to ANAND VIHAR via YAMUNA EXPRESSWAY": "Trips Details"}
          </span>
        </div>
        <SearchInputsComponent
          startDate={startDate}
          routeName={routeName}
          direction={direction}
          etmRoutes={etmRoutes}
          directions={directions}
          focusedStartDate={this.state.focusedStartDate}
          onStartDateChange={this.onStartDateChange}
          onStartFocusChange={this.onStartFocusChange}
          startDateRangeChecker={this.startDateRangeChecker}
          onRouteChange={this.onRouteChange}
          onDirectionChange={this.onDirectionChange}
          onSearchClick={this.onSearchClick}
        />
        {
          isDataFetched &&
            <TripsTableComponent
              tableData={tripsData}
              onTripDetailsClick={this.onTripDetailsClick}
            />
        }
      </div>
    )
  }
}


const mapStateToProps = store => ({
  startDate: store.etmTicketsReducer.startDate,
  routeName: store.etmTicketsReducer.routeName,
  direction: store.etmTicketsReducer.direction,
  tripsData: store.etmTicketsReducer.tripsData,
  etmRoutes: store.etmTicketsReducer.etmRoutes,
  directions: store.etmTicketsReducer.directions
})

const mapDispatchToProps = dispatch => ({
  getTripsDetails: (query) => dispatch(actions.getTripsDetails(query)),
  updateInputValues: (data) => dispatch(actions.updateInputValues(data)),
  clearTicketDetails: () => dispatch(actions.clearTicketDetails()),
  getETMRoutes: () => dispatch(actions.getETMRoutes()),
})

TripDetailsContainer.propTypes = {
  tripsData: PropTypes.array.isRequired,
  getTripsDetails: PropTypes.func.isRequired,
  getETMRoutes: PropTypes.func.isRequired,
  updateInputValues: PropTypes.func.isRequired,
  clearTicketDetails: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(TripDetailsContainer)
